import React, { useState } from "react";
import styles from "./ShareOpportunity.module.scss";
import { Tabs, Tab } from "@blueprintjs/core";
import CopyLinkTab from "./CopyLinkTab";
import SocialTab from "./SocialTab";
import { EmailTab } from "./EmailTab";
import congrats from "../../../assets/congrats.svg";
import share from "../../../assets/share.svg";

export default function ShareOpportunity({
  opportunityId,
  shareOpportunity,
  setShowShare,
  onDismiss
}) {
  const [selectedTabId, setSelectedTabId] = useState("copyLink");

  return (
    <div className={styles.shareOpportunity}>
      <div className={styles.container}>
        <div className={styles.contentHolder}>
          <div className={styles.imageWrapper}>
            <img
              className={styles.congratsImage}
              alt={shareOpportunity ? "Share" : "Congratulations"}
              src={shareOpportunity ? share : congrats}
            />
          </div>
          <div>
            <h2 className={styles.header}>
              {shareOpportunity
                ? "Share this Opportunity!"
                : "Congratulations on creating an opportunity!"}
            </h2>
          </div>
          <div>
            <p className={styles.paragraph}>
              {shareOpportunity
                ? "With the options below, you have the power to share this opportunity with your network of influencers to invite them to this opportunity!"
                : "Now that you've created an opportunity for your product, you're ready to begin sharing to the masses!"}
            </p>
          </div>
        </div>
      </div>
      <h4 className={styles.shareTitle}>Share this opportunity</h4>
      <Tabs
        selectedTabId={selectedTabId}
        onChange={(tabId) => setSelectedTabId(tabId)}
      >
        <Tab
          id="copyLink"
          title="Link"
          panel={<CopyLinkTab opportunityId={opportunityId} />}
        />
        <Tab
          id="social"
          title="Social"
          panel={
            <SocialTab
              opportunityId={opportunityId}
              onCopyLinkClick={() => setSelectedTabId("copyLink")}
            />
          }
        />
        <Tab
          id="email"
          title="Email"
          panel={
            <EmailTab
              opportunityId={opportunityId}
              setShowShare={setShowShare}
              onDismiss={onDismiss}
            />
          }
        />
      </Tabs>
    </div>
  );
}
